
export const supportsAnchorPositioning = CSS.supports('anchor-name', '--my-anchor') && CSS.supports('position-anchor', '--my-anchor') && CSS.supports('top', 'anchor(top)');

// top | bottom + [left | span-left | center | span-right | right] 
// left | right + [span-top | center | span-bottom]

// todo: some method that both sets the anchor on the target if supported, and if not computes its absolute coordinates (in the closest shared relative parent between it and the popup) and set those coordinates on the popup

export function setAnchor(element: HTMLElement, name?: string | null) {
    if (element.id && !name) {
        name = element.id;
    }
    if (!name) return null;
    if (!name?.startsWith("--")) {
        name = "--" + name;
    }
    // Remove anchor name from any existing elements that have the same anchor name
    document.querySelectorAll('[data-has-anchor="true"]').forEach((anchoredElement) => {
        if (anchoredElement !== element && anchoredElement instanceof HTMLElement && anchoredElement.style.anchorName === name) {
            anchoredElement.style.anchorName = "";
            anchoredElement.removeAttribute("data-has-anchor");
        }
    });
    element.setAttribute("data-has-anchor", "true");
    element.style.anchorName = name;
    return name;
}

export function findAnchorElement(name: string): HTMLElement {
    return Array.from(document.querySelectorAll(
        '[data-has-anchor="true"]'
    )).find(n => n instanceof HTMLElement && (n as HTMLElement).style?.anchorName == name) as HTMLElement;
}

